function convertToDate(obj) {
  if (!obj || typeof obj !== "object") return null;

  if ("time" in obj && typeof obj.time === "number") {
    return new Date(obj.time);
  }

  const {
    year,
    month,
    date,
    hours,
    minutes,
    seconds,
  } = obj;

  if (
    typeof year !== "number" ||
    typeof month !== "number" ||
    typeof date !== "number"
  ) {
    return null;
  }

  return new Date(
    1900 + year,
    month,
    date,
    hours || 0,
    minutes || 0,
    seconds || 0
  );
}

const formatCreatedAt = (createdAt) => {
  const date = new Date(createdAt);
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}

const formatFileSize = (bytes) => {
  if (bytes < 1024) return bytes + " B";
  else if (bytes < 1048576) return (bytes / 1024).toFixed(1) + " KB";
  else if (bytes < 1073741824) return (bytes / 1048576).toFixed(1) + " MB";
  else return (bytes / 1073741824).toFixed(1) + " GB";
}

const formatTo24Hour = (input) => {
  let date;

  if (typeof input === "object" && input !== null) {
    date = convertToDate(input);
  } else {
    date = new Date(input);
  }

  if (!date || isNaN(date.getTime())) return "Invalid date";

  return date.toLocaleTimeString("vi-VN", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
};

const getFileNameFromUrl = (url) => {
  if (!url) return "";
    // Lấy phần sau dấu "_" cuối cùng
    const lastUnderscoreIndex = url.lastIndexOf("_");
  if (lastUnderscoreIndex === -1) {
    // Nếu không có "_" thì lấy phần sau dấu "/"
    return url.substring(url.lastIndexOf("/") + 1);
  }
  return url.substring(lastUnderscoreIndex + 1);
}

const formatMessage = (raw) => {
  if (!raw) return "";
  return raw
    .replace(/\/\/n/g, "\n") 
    .replace(/^\/\/\s*/gm, '') 
    .replace(/###(.*?)###/g, '### $1') 
    .replace(/\n(?!\s*([-*+]|\d+\.)\s)/g, '\n\n')
    .trim();
}

const formatFileName = (name) => {
  const parts = name.split(".");
  const extension = parts.pop();
  const baseName = parts.join(".");

  const slug = baseName
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // bỏ dấu
    .replace(/đ/g, "d").replace(/Đ/g, "D")
    .replace(/[^a-zA-Z0-9]+/g, "-") // ký tự đặc biệt & khoảng trắng → "-"
    .replace(/^-+|-+$/g, "") // bỏ "-" đầu/cuối
    .toLowerCase();

  return `${slug}.${extension.toLowerCase()}`;
};

const formatMessageNote = (raw) => {
  if (!raw) return "";
  return raw
    .replace(/\/\/n/g, "\n") // thay //n thành xuống dòng
    .replace(/###(.*?)###/g, '### $1') // tiêu đề h3
    .replace(/\n(?!\s*([-*+]|\d+\.)\s)/g, '\n\n') // Normalize markdown: thêm một dòng trống trước các đoạn không phải list item
    // .replace(/n\*\*/g, "\n**") // xuống dòng trước tiêu đề bold
    // .replace(/n-/g, "\n-") // xuống dòng trước list item
    // .replace(/n/g, "\n") // fallback: n -> xuống dòng
    .trim();  
}

const GROUP_TIME_MS = 3000;


const canGroup = (prev, curr) => {
  if (!prev || !curr) return false;

  // chỉ gộp BOT/BOT hoặc ADMIN/ADMIN
  if (prev.isCustomer || curr.isCustomer) return false;

  const prevTime = new Date(prev.createdAt).getTime();
  const currTime = new Date(curr.createdAt).getTime();

  // ⚠️ bắt buộc có createdAt hợp lệ
  if (isNaN(prevTime) || isNaN(currTime)) return false;

  return currTime - prevTime <= 3000;
};


const Help = {
  convertToDate,
  formatCreatedAt,
  formatFileSize,
  formatTo24Hour,
  getFileNameFromUrl,
  formatMessage,
  formatFileName,
  formatMessageNote,
  canGroup,
};

export default Help;
